// @flow
import { connect } from 'react-redux';
import ScribeConversations from './ScribeConversations';
import { fetchTranscripts } from '../../actions';
import { handleNewRoomStatus } from '../../actions/conversation';

const mapStateToProps = state => ({
  conversations: state.scribeConversation.conversations,
  loading: state.scribeSession.loading,
  backends: state.scribeSession.backends,
  fontSize: state.scribeTranscriptUI.fontSize,
});

export default connect(
  mapStateToProps,
  { fetchTranscripts, handleNewRoomStatus }
)(ScribeConversations);
